/* GODS & KINGS — reinforce pre-launch status at the point of product intent */
(function(){
 function apply(){
  var section=document.querySelector('#ritual')||document.querySelector('#system');
  if(!section||section.querySelector('.gk-prelaunch-ritual'))return;
  var grid=section.querySelector('.gk-product-grid');
  if(!grid)return;
  var notice=document.createElement('div');notice.className='gk-prelaunch-ritual';notice.setAttribute('role','note');
  notice.innerHTML='<div class="gk-prelaunch-ritual__label">THE INAUGURAL COLLECTION · COMING SOON</div><p class="gk-prelaunch-ritual__copy">CODE ZERO™, DIVINIUM™ and SENTINEL™ are preparing for release and are not yet available to purchase.</p><a class="gk-prelaunch-ritual__link" href="#newsletter">JOIN THE FOUNDER\'S LIST →</a>';
  grid.parentNode.insertBefore(notice,grid);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply);else apply();document.addEventListener('shopify:section:load',apply);
})();
